/**
 * Envío ER-2 · Cualquier error (string, objeto de FastAPI, lista de errores de
 * validación, Error de JS) convertido en un texto que React puede dibujar.
 *
 * Por qué: FastAPI devuelve `detail` como LISTA de objetos cuando un pedido no
 * pasa la validación (422). Si ese valor llega tal cual a un toast o a un
 * <span>, React lanza «Objects are not valid as a React child» y, sin red de
 * seguridad, se cae toda la aplicación (pantalla negra).
 */
import { isValidElement } from 'react';

export const VALIDATION_TEXT = 'Faltan datos o hay datos inválidos en el pedido.';

const isPydanticError = (v) => v && typeof v === 'object' && 'loc' in v && 'msg' in v;

export function errorText(value, fallback = 'Ocurrió un error. Probá de nuevo.') {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (value instanceof Error) return value.message || fallback;
  if (Array.isArray(value)) {
    if (value.some(isPydanticError)) return VALIDATION_TEXT;
    const parts = value.map((v) => errorText(v, '')).filter(Boolean);
    return parts.length ? parts.join(' · ') : fallback;
  }
  if (typeof value === 'object') {
    if (isPydanticError(value)) return VALIDATION_TEXT;
    if ('detail' in value) return errorText(value.detail, fallback);
    if (typeof value.message === 'string' && value.message) return value.message;
    if (typeof value.msg === 'string' && value.msg) return value.msg;
  }
  return fallback;
}

/** Igual que errorText, pero deja pasar elementos de React (toasts con JSX). */
export function renderableText(value, fallback) {
  if (isValidElement(value) || typeof value === 'function') return value;
  return errorText(value, fallback);
}
